import { View, Text } from "@react-pdf/renderer";
import { capitalizeFirstLetter } from "../../../../../helpers/functions";
import { COLORS, styles } from "../../../../forms/pdf-components/PdfStyles";

/**
 * PdfAllergyInformation
 * Renders: "Allergy Information: AllergyName1, AllergyName2, ..."
 *
 * Props:
 *   patient            — patient object
 *   clinicalAssessment — { confirmedAllergy: string[] }
 */
export const PdfAllergyInformation = ({
  patient = {},
  clinicalAssessment = {},
}) => {
  const confirmedIds = (clinicalAssessment?.confirmedAllergy || []).map((id) =>
    String(id)
  );
  const allAllergies = patient?.allergyInfo?.allergies || [];

  const activeAllergies = allAllergies.filter(
    (a) => String(a?.status || "").toLowerCase() === "active"
  );

  const filteredAllergies =
    confirmedIds.length > 0
      ? activeAllergies.filter((a) => confirmedIds.includes(String(a?.id)))
      : activeAllergies;

  const allergyNames =
    filteredAllergies.length > 0
      ? filteredAllergies
          .map((a) => capitalizeFirstLetter(a.allergyName))
          .join(", ")
      : "No Known Allergies";

  return (
    <View
      style={{
        borderWidth: 1,
        borderColor: COLORS.border,
        backgroundColor: COLORS.bgSection,
        padding: 6,
        flexDirection: "row",
        flexWrap: "wrap",
      }}
    >
      <Text style={styles.inlineBold}>Allergy Information:&nbsp;</Text>
      <Text style={styles.inlineBold}>{allergyNames}</Text>
    </View>
  );
};
